import React from "react"
import Dropzone, { DropEvent, FileRejection } from "react-dropzone"
import { Box, Button, Typography } from "@carrotfertility/carotene-core"
import { AcceptableFileExtensions } from "#/components/views/reimbursements/upload/AcceptableFileExtensions"
import { FormattedMessage } from "react-intl"

// @ts-expect-error TS(7031) FIXME: Binding element 'isDragActive' implicitly has an '... Remove this comment to see the full error message
const NewDropzoneIllustration = ({ isDragActive }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      paddingBlockStart: isDragActive ? (theme) => theme.tokens.spacing.xl : 0,
      paddingBlockEnd: isDragActive ? (theme) => theme.tokens.spacing.xxxl : 0,
      gap: (theme) => theme.spacing(theme.tokens.spacing.md)
    }}
  >
    {isDragActive ? (
      <Typography variant="h5" component="p">
        <FormattedMessage defaultMessage="Drop files to upload" />
      </Typography>
    ) : (
      <>
        <Typography variant="h5" component="p">
          <FormattedMessage defaultMessage="Drag and drop files here" />
        </Typography>
        <Typography variant="body2">
          <FormattedMessage defaultMessage="or" />
        </Typography>
        <Button
          sx={{ inlineSize: "fit-content", alignSelf: "center" }}
          variant="outlined"
          size="medium"
          color="secondary"
        >
          <FormattedMessage defaultMessage="Add files" />
        </Button>
      </>
    )}
  </Box>
)

const UploadDropzoneWithIllustration = ({
  small,
  onDropAccepted,
  onDropRejected
}: {
  small: boolean
  onDropAccepted?: <T extends File>(files: T[], event: DropEvent) => void
  onDropRejected: (fileRejections: FileRejection[], event: DropEvent) => void
}) => {
  return (
    <Dropzone
      multiple
      onDropAccepted={onDropAccepted}
      onDropRejected={onDropRejected}
      accept={AcceptableFileExtensions}
    >
      {({ getRootProps, getInputProps, isDragActive }) => (
        <div
          className={`
          bg-light-gray w-100 br3 pointer no-outline tc lh-solid ph3 animate-all-slow ${small ? "pv35" : "pv5"} ${
            isDragActive ? "ba bw1 b--carrot-orange" : "ba bw1 b--moon-gray"
          }`}
          {...getRootProps()}
        >
          {isDragActive ? <div className="fullscreen-dropzone-overlay" /> : ""}
          <input id="upload-files-input" data-testid="upload-files-input-test" {...getInputProps()} />
          <NewDropzoneIllustration isDragActive={isDragActive} />
        </div>
      )}
    </Dropzone>
  )
}

export { UploadDropzoneWithIllustration }
